import AdminStats from './AdminStatsComponent';
import AdminNavMain from './AdminNavComponent';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers, userDeleted } from '../../redux/usersSlice';
import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

function UserAdmin(){

    const deleteUser = async (event) => {
        const deletePromiseResponse = await fetch(process.env.REACT_APP_DATABASE_URL + '/users', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                userId: event.target.dataset.userId
            })
        });

        const deleteResponse = await deletePromiseResponse.json();

        if(deleteResponse.success){
            dispatch(userDeleted(deleteResponse.user_id));
            alert(deleteResponse.message);
        } else if (deleteResponse.message) {
            alert(deleteResponse.message);
        } else if (deleteResponse.description){
            alert(`Issue deleting user entry. Code: ${deleteResponse.code}. Description: ${deleteResponse.description}`);
        } else {
            alert(`Error: ${deleteResponse.error}. ${deleteResponse.status}`);
        }

    };

    const dispatch = useDispatch();

    const [accessToken, setAccessToken] = useState('emptyTokenInAdmin');
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {

        const getAccessToken = async() => {
            try {
                const jwt = await getAccessTokenSilently();
                setAccessToken(jwt);
                dispatch(fetchUsers(jwt));
            } catch (error) {
                // token retrieval failed
            }
        };

        getAccessToken();

    }, [getAccessTokenSilently, dispatch]);


    const listUsers = useSelector(state => state.users.usersArray);

    const usersListCards = listUsers.map((user) => {
        const gamesIdList = user.games.join(', ');

        return(
            <div className="border border-gray-200 rounded bg-white p-4 shadow-sm" key={user.id}>
                <h5 className="font-semibold text-lg mb-2">User id: {user.id}</h5>
                <p className="text-sm text-gray-700">
                    <b>Number of connections:</b> {user.numb_connections}<br /><br />
                    <b>Average success rate:</b> {user.average_success_rate}<br /><br />
                    <b>Games played:</b><br />{gamesIdList}
                </p>
                <button
                    className="mt-2 px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                    data-user-id={user.id}
                    onClick={deleteUser}>
                        Delete
                </button>
            </div>
        )
    });

    const usersListTable = listUsers.map((user) => {
        const gamesIdList = user.games.join(', ');

        return(
            <tr key={user.id} className="border-b border-gray-200 hover:bg-gray-50">
                <td className="px-4 py-2 text-sm font-medium">{user.id}</td>
                <td className="px-4 py-2 text-sm">{user.numb_connections}</td>
                <td className="px-4 py-2 text-sm">{user.average_success_rate}</td>
                <td className="px-4 py-2 text-sm">{gamesIdList}</td>
                <td className="px-4 py-2">
                    <button
                        className="px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                        data-user-id={user.id}
                        onClick={deleteUser}>
                            Delete
                    </button>
                </td>
            </tr>
        )
    });

    return(
        <>
            <AdminNavMain />
            <div className="max-w-7xl mx-auto px-4 pt-16">
                <h1 className="text-2xl font-bold text-gray-800 my-4">User Admin</h1>
            </div>
            <AdminStats />
            <div className="max-w-7xl mx-auto px-4">
                {/* Table view for md+ */}
                <div className="hidden md:block overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="bg-gray-100 border-b-2 border-gray-300">
                                <th className="px-4 py-2 text-sm font-semibold">User id</th>
                                <th className="px-4 py-2 text-sm font-semibold">Number of connections</th>
                                <th className="px-4 py-2 text-sm font-semibold">Average success rate</th>
                                <th className="px-4 py-2 text-sm font-semibold">Games played</th>
                                <th className="px-4 py-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {usersListTable}
                        </tbody>
                    </table>
                </div>
                {/* Card view for mobile */}
                <div className="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {usersListCards}
                </div>
            </div>
        </>
    )
}

export default UserAdmin;
